import { ListItemIcon, styled } from '@mui/material';

const StyledAvailabilityStatusListIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 'auto',
  marginRight: theme.spacing(2)
}));

export default StyledAvailabilityStatusListIcon;
